import { render, staticRenderFns } from "./WxOpenTag.vue?vue&type=template&id=3b8648ac&scoped=true"
import script from "./WxOpenTag.vue?vue&type=script&lang=js"
export * from "./WxOpenTag.vue?vue&type=script&lang=js"
import style0 from "./WxOpenTag.vue?vue&type=style&index=0&id=3b8648ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8648ac",
  null
  
)

export default component.exports